import React from 'react'

import { NotificationCategoriesContext } from './context/NotificationCategoriesContext'
import { useNotificationsAccessGuard } from './hooks/useNotificationsAccessGuard'

interface NotificationsAccessGuardProps {
  children: React.ReactNode
  errorMessage?: string
}

const NotificationsAccessGuard = ({ children, errorMessage }: NotificationsAccessGuardProps) => {
  const { state, categories } = useNotificationsAccessGuard(errorMessage)

  if (state === 'loading') return null  // silent — nothing renders until API resolves
  if (state === 'denied')  return null  // no categories for this customer — hide bell

  return (
    <NotificationCategoriesContext.Provider value={categories}>
      {children}
    </NotificationCategoriesContext.Provider>
  )
}

export default NotificationsAccessGuard
